<template>
  <div>
    <swiss-topo v-if="usingSwissTopo" />
    <google-map v-else />
  </div>
</template>

<script>
import GoogleTrafficMap from '@/components/map/google/TrafficMap';
import SwissTopoTrafficMap from '@/components/map/swisstopo/TrafficMap';

export default {
  components: {
    'google-map': GoogleTrafficMap,
    'swiss-topo': SwissTopoTrafficMap,
  },

  computed: {
    usingSwissTopo() {
      return process.env.VUE_APP_MAP_SUPPLIER?.toLowerCase() == 'swisstopo';
    },
  },
};
</script>
